var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnectSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1602_21226)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 20.3438C15.9366 20.3438 20.3438 15.9366 20.3438 10.5C20.3438 5.06345 15.9366 0.65625 10.5 0.65625C5.06345 0.65625 0.65625 5.06345 0.65625 10.5C0.65625 15.9366 5.06345 20.3438 10.5 20.3438Z",
    fill: "url(#paint0_radial_1602_21226)",
    stroke: "url(#paint1_radial_1602_21226)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1602_21226)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.209 13.8433L7.72839 15.4088C7.11456 16.0578 6.12051 16.0578 5.5072 15.4089C4.89376 14.7603 4.89376 13.7092 5.50707 13.0608L8.4688 9.92937C9.08212 9.2809 10.0763 9.2809 10.6896 9.92937C10.894 10.1455 11.2255 10.1455 11.43 9.92937C11.6344 9.71321 11.6344 9.36271 11.43 9.14654C10.4077 8.06574 8.75064 8.06574 7.72839 9.14654L4.76669 12.2779C3.74444 13.3587 3.74444 15.1108 4.76669 16.1916C5.78881 17.2729 7.44604 17.2729 8.46883 16.1916L9.94944 14.6261C10.1539 14.41 10.1539 14.0595 9.94944 13.8433C9.74498 13.6271 9.41345 13.6272 9.209 13.8433Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1568 4.83131C15.0324 3.7229 13.2091 3.7229 12.0847 4.83131L10.1307 6.75744C9.90584 6.97913 9.90584 7.33857 10.1307 7.56026C10.3556 7.78195 10.7203 7.78195 10.9451 7.56026L12.8991 5.63413C13.5737 4.96909 14.6678 4.96909 15.3424 5.63413C16.017 6.29914 16.017 7.37708 15.3424 8.04209L11.7593 11.5742C11.0847 12.2392 9.99119 12.2392 9.31658 11.5742C9.09169 11.3525 8.72705 11.3525 8.50216 11.5742C8.27727 11.7959 8.27727 12.1553 8.50216 12.377C9.62658 13.4854 11.4493 13.4854 12.5737 12.377L16.1568 8.84493C17.2813 7.73652 17.2813 5.93972 16.1568 4.83131Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1602_21226",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.38221 4.29087) rotate(51.6048) scale(20.4823)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8EDAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#71CBC6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1602_21226",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.38221 4.29087) rotate(51.6048) scale(20.4823)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8EDAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#71CBC6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1602_21226"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1602_21226"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectSelected);
export default __webpack_public_path__ + "static/media/connect-selected.db7e7f47a026afa880f373c17602f4ec.svg";
export { ForwardRef as ReactComponent };